export const infoModal = {
  controller: class {

    $onInit() {
      this.title = this.title || 'Info'
    }

    resolve(value) {
      this.close({value});
    }

  },
  bindings: {
    close: '&',
    title: '<heading',
    description: '<',
  },
  template: `
    <div class="modal-header">
      <span ng-bind-html='$ctrl.title'></span>
    </div>
    <div class="modal-body" id="modal-body" ng-bind-html='$ctrl.description'></div>
    <div class="modal-footer">
      <button type="button" class='save-standard' ng-click="$ctrl.resolve(true)">Okay</button>
    </div>
  `,
}
